import { useTranslations } from "use-intl";

import { SwipeableDrawer } from "@/components/Drawer/SwipeableDrawer";
import { TripTourPlan } from "@/features/trips/components/bookingFlow/tripDetails/TripTourPlanCard";
import type { TripDetails } from "@/features/trips/types/types";
import { formatCurrency } from "@/utils/currency";

type TripTourDrawerProps = {
  trip: TripDetails;
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
};

export function TripTourDrawer({
  trip,
  open,
  onClose,
  children,
}: TripTourDrawerProps) {
  const t = useTranslations();

  return (
    <SwipeableDrawer open={open} onClose={onClose}>
      <div className="mb-4">
        <h2 className="font-medium">
          {t("trips.tours.drawer.title", { city: trip.cities })}
        </h2>
        <p className="text-sm text-text-tertiary">
          {t("trips.tours.drawer.subtitle")}
        </p>
      </div>

      <TripTourPlan itineraries={trip.itineraries} />

      <div className="-mx-4 mt-4 -mb-8 rounded-t-4xl border border-neutral-200 px-4 pt-4 pb-8 shadow-[0_-1px_12px_0_rgba(0,0,0,0.08),0_-4px_12px_0_rgba(0,0,0,0.04)]">
        <dl className="mb-4 grid grid-cols-2 items-center gap-2 text-sm">
          <dt>{t("trips.tours.drawer.priceNotice")}</dt>
          <dd className="text-end text-base font-bold">
            +{formatCurrency(trip.tourPrice)}
          </dd>
        </dl>

        <div className="flex gap-2">{children}</div>
      </div>
    </SwipeableDrawer>
  );
}
